import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { LandingpageConfigurationStateService } from 'app/shared/services/state/landingpage-configuration-state.service';

@Component({
  selector: 'ez-already-sent',
  imports: [MainLayoutComponent],
  templateUrl: './already-sent.component.html',
  styleUrl: './already-sent.component.scss',
})
export class AlreadySentComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private stateService = inject(LandingpageConfigurationStateService);

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    if (!code) return;
    this.stateService.fetchPublicOrganisationForToken(code).catch(() => undefined);
  }
}
